import {
    addFdListener,
    FreezeDryItemTypes,
    EventTypes,
    lazyCreateOrUpdateMainWindowItem,
} from 'owa-freeze-dry';
import { createMainWindowItem } from './createMainWindowItem';
import { logGreyError } from 'owa-analytics';
import { type MainWindow } from 'owa-freeze-dry';

function handlePersistScrollPosition() {
    try {
        const mainWindow: Partial<MainWindow> = createMainWindowItem();
        if (mainWindow) {
            lazyCreateOrUpdateMainWindowItem.importAndExecute(mainWindow);
        } else {
            logGreyError('FreezeDryPersistScrollPositionError: mainWindow is undefined');
        }
    } catch (e) {
        logGreyError('FreezeDryPersistScrollPositionError', e);
    }
}

// Add the listener to 'fdEventManager'
export function initializePersistMailListener() {
    addFdListener(EventTypes.Persist, FreezeDryItemTypes.MainWindow, handlePersistScrollPosition);
}
